// extracted by mini-css-extract-plugin
export default {"wrapper":"CourseReview_wrapper__tizMl","text":"CourseReview_text__s3WwW","actions":"CourseReview_actions__Kcjt8","line":"CourseReview_line__C2u9Y"};